import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Flame } from 'lucide-react';
export function ProblemSection() {
  return <SectionWrapper bgColor="sage" data-id="element-127">
      <div className="flex items-center gap-4 mb-8" data-id="element-128">
        <Flame className="w-10 h-10 text-brand-amber flex-shrink-0" data-id="element-129" />
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-forest" data-id="element-130">
          El problema real no es la comida
        </h2>
      </div>

      <div className="space-y-6 text-lg md:text-xl text-gray-800 leading-relaxed" data-id="element-131">
        <p data-id="element-132">
          Después de los 50, la "puerta" de tu estómago (el esfínter esofágico)
          pierde fuerza y tu producción de ácido natural disminuye.
        </p>

        <div className="bg-white/60 p-6 rounded-xl border border-brand-forest/10 shadow-sm my-8" data-id="element-133">
          <p className="font-medium" data-id="element-134">
            Esto crea un efecto de fermentación: la comida se queda estancada,
            genera gas y empuja el ácido hacia tu garganta.
          </p>
        </div>

        <p data-id="element-135">
          No es que la comida latina sea "mala", es que tu sistema actual no
          tiene las herramientas para desarmar los gatillos químicos del ajo,
          las grasas saturadas y los condimentos pesados.
        </p>

        <p data-id="element-136">
          Vivir a base de pastillas masticables solo apaga el incendio
          momentáneamente, mientras debilita aún más tu digestión real.
        </p>
      </div>
    </SectionWrapper>;
}